import React from "react";
import {
  Box,
  Stack,
  Text,
  Image,
  Flex,
  Grid,
  Icon,
  GridItem,
} from "@chakra-ui/react";
import { FilledButton } from "./Button";
import AppointButton from "./AppointButton";

const ChooseGrid = ({ showImage = true }) => {
  const features = [
    {
      icon: "../assets/guide.png",
      title: "Expert Guidance",
      tagline: "Professional Advice from Experienced Tax Specialists",
      description:
        "Our team consists of seasoned tax and finance professionals who are here to guide you every step of the way. Whether it's ITR, GST, or business registration, you're in expert hands.",
    },
    {
      icon: "../assets/spam.png",
      title: "No Spam Guaranteed",
      tagline: "Respecting Your Privacy – No Spam, Just Trusted Tax Advice.",
      description:
        "We respect your privacy and won’t reach out without your consent. Our tax advisory service ensures you won’t receive unsolicited calls or messages.",
    },
    {
      icon: "../assets/affordable.png",
      title: "Affordable Pricing",
      tagline: "Transparent and Competitive Rates with No Hidden Fees",
      description:
        "We believe in clear, upfront pricing, so you know exactly what you’re paying for.",
    },
    {
      icon: "../assets/trusted.png",
      title: "Certified and Trusted",
      tagline: "Your Trusted Partners in Tax and Compliance",
      description:
        "Every client is different, so we take the time to provide customized solutions that fit you best.",
    },
    {
      icon: "../assets/quick.png",
      title: "Quick & Hassle-Free Process",
      tagline: "Streamlined Solutions to Save You Time",
      description:
        "We’ve simplified our processes to make everything as quick and easy as possible.",
    },
    {
      icon: "../assets/data.png",
      title: "Data Security",
      tagline: "Your Privacy and Data Security Are Our Top Priority",
      description:
        "Advanced security measures keep your data safe and confidential.",
    },
  ];
  return (
    <Grid
      templateColumns={{ base: "1fr", lg: showImage ? "1fr 1.5fr" : "1fr" }}
      px={{ base: "5", md: "20" }}
      py="5"
      gap={10}
      justifyItems="center"
    >
      {showImage && (
        <GridItem w="fit-content">
          <Image
            src="../assets/choose.svg"
            height={{ base: "270px", md: "390px" }}
            w="auto"
            loading="lazy"
          />
        </GridItem>
      )}
      <GridItem>
        <Stack alignItems="center" gap={10}>
          <Grid templateColumns="repeat(2, 1fr)" gap="10">
            {features.map((feature) => (
              <Flex
                key={feature.title}
                gap={5}
                direction={{ base: "column", md: "row" }}
                alignItems={{ base: "center", md: "start" }}
              >
                <Image src={feature.icon} boxSize="10" />
                <Stack textAlign={{ base: "center", md: "left" }}>
                  <Text
                    fontSize={{ base: "md", md: "xl" }}
                    fontWeight="semibold"
                  >
                    {feature.title}
                  </Text>
                  <Text
                    fontSize={{ base: "sm", md: "md" }}
                    color="gray.500"
                    display={{ base: "none", md: "block" }}
                  >
                    {feature.tagline}
                  </Text>
                </Stack>
              </Flex>
            ))}
          </Grid>
          <AppointButton text={<FilledButton title="Get Started Today" />} />
        </Stack>
      </GridItem>
    </Grid>
  );
};

export default ChooseGrid;
